import React from 'react';

const ink = '#1a1a1a';

const SvgIcon = ({ size = 24, color = ink, children, viewBox = '0 0 24 24' }) => (
    <svg
        width={size}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        style={{ display: 'block', flexShrink: 0, color }}
    >
        {children}
    </svg>
);

export const IconBack = ({ size = 24, color = ink }) => (
    <SvgIcon size={size} color={color}>
        <path d="M15 6L9 12L15 18" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
);

export const IconHome = ({ size = 24, color = ink }) => (
    <SvgIcon size={size} color={color}>
        <path d="M4 10.5L12 4L20 10.5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V10.5Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
        <path d="M10 20V13H14V20" stroke={color} strokeWidth="2" strokeLinejoin="round" />
    </SvgIcon>
);

export const IconExit = ({ size = 24, color = ink }) => (
    <SvgIcon size={size} color={color}>
        <path d="M12 3V12" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" />
        <path d="M8 16H16" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
);

export const IconProfile = ({ size = 24, color = ink }) => (
    <SvgIcon size={size} color={color}>
        <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="2" />
        <path d="M5 20C5 16.134 8.13401 13 12 13C15.866 13 19 16.134 19 20" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
);

export const IconAudio = ({ size = 24, color = ink }) => (
    <SvgIcon size={size} color={color}>
        <path d="M9 18V6L18 4V16" stroke={color} strokeWidth="2" strokeLinejoin="round" />
        <circle cx="7" cy="18" r="3" stroke={color} strokeWidth="2" />
        <circle cx="16" cy="16" r="3" stroke={color} strokeWidth="2" />
    </SvgIcon>
);

export const IconQuiz = ({ size = 24, color = ink }) => (
    <SvgIcon size={size} color={color}>
        <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" />
        <path d="M12 16V16.01" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
        <path d="M12 13C12 11.5 14 11 14 9.5C14 8.39543 13.1046 7.5 12 7.5C10.8954 7.5 10 8.39543 10 9.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
);

export const IconPlaylist = ({ size = 24, color = ink }) => (
    <SvgIcon size={size} color={color}>
        <path d="M5 6H19" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M5 12H19" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M5 18H14" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <circle cx="18" cy="18" r="2" fill={color} />
    </SvgIcon>
);

export const IconSettings = ({ size = 24, color = ink }) => (
    <SvgIcon size={size} color={color}>
        <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2" />
        <path
            d="M12 2V4M12 20V22M4.93 4.93L6.34 6.34M17.66 17.66L19.07 19.07M2 12H4M20 12H22M4.93 19.07L6.34 17.66M17.66 6.34L19.07 4.93"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
        />
    </SvgIcon>
);

export const IconMenu = ({ size = 24, color = ink }) => (
    <SvgIcon size={size} color={color}>
        <path d="M4 7H20" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M4 12H20" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M4 17H20" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
);

export const IconClose = ({ size = 24, color = ink }) => (
    <SvgIcon size={size} color={color}>
        <path d="M6 6L18 18M18 6L6 18" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
    </SvgIcon>
);

export const IconUsers = ({ size = 24, color = ink }) => (
    <SvgIcon size={size} color={color}>
        <circle cx="9" cy="8" r="3" stroke={color} strokeWidth="2" />
        <path d="M3 20C3 16.6863 5.68629 14 9 14" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <circle cx="17" cy="9" r="2.5" stroke={color} strokeWidth="2" />
        <path d="M14 20C14 17.2386 15.7909 15.5 17.5 15.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
);

const icons = {
    audio: <IconAudio size={40} />,
    quiz: <IconQuiz size={40} />,
    users: <IconUsers size={24} />,
    courses: <IconAudio size={24} />,
    new: <IconQuiz size={24} />,
    settings: <IconSettings size={24} />,
    home: <IconHome size={24} />,
    profile: <IconProfile size={22} />,
    logout: <IconExit size={24} />,
    menu: <IconMenu size={24} />,
    close: <IconClose size={24} />,
    playlist: <IconPlaylist size={24} />,
    back: <IconBack size={24} />,
};

export default icons;
